import type { Token, Tokens } from 'marked';

export const MATH_BLOCK_TOKEN_NAME = 'math_block';
export const MATH_INLINE_TOKEN_NAME = 'math_inline';

export interface MathBlockToken extends Tokens.Generic {
  type: typeof MATH_BLOCK_TOKEN_NAME;
  raw: string;
  text: string;
  displayMode: true;
}

export interface MathInlineToken extends Tokens.Generic {
  type: typeof MATH_INLINE_TOKEN_NAME;
  raw: string;
  text: string;
  // `true` when matched as `$$…$$` inline (mid-paragraph display math),
  // `false` for the standard `$…$` form. Both flow through the same renderer.
  displayMode: boolean;
}

export function isMathBlockToken(token: Token): token is MathBlockToken {
  if (token.type !== MATH_BLOCK_TOKEN_NAME) {
    return false;
  }

  return 'displayMode' in token && token.displayMode === true && 'text' in token;
}

export function isMathInlineToken(token: Token): token is MathInlineToken {
  if (token.type !== MATH_INLINE_TOKEN_NAME) {
    return false;
  }

  return 'displayMode' in token && typeof token.displayMode === 'boolean' && 'text' in token;
}
